// Estados del informe (IND 355).
export const ESTADO_BORRADOR = 355001;
export const ESTADO_ENVIADO = 355002;
export const ESTADO_REVISADO = 355003;

export const PERFIL_ABOGADO = 'ABOGADO';

// Sección 7 (decisión de la compañía) en la vista del abogado: no se muestra en el informe inicial (versión 1); desde la versión 2 se
// muestra solo de lectura (respuesta del analista, Jira 58067, punto 19). Con un informe «Enviado» y aún sin revisar se muestra el mensaje.
export const MSG_SECCION7_PENDIENTE = 'Pendiente de revisión por el analista';

// Busca la glosa de un id en un combo plano ([{id, glosa}]) o agrupado ([{id, glosa, items:[{id, glosa}]}]).
export const glosaCombo = (combo, id) => {
    if (id === null || id === undefined || !Array.isArray(combo)) return '';

    for (const opcion of combo) {
        if (opcion.id === id) return opcion.glosa;
        if (Array.isArray(opcion.items)) {
            const item = opcion.items.find((i) => i.id === id);
            if (item) return item.glosa;
        }
    }
    return '';
}

// 'AAAA-MM-DD' → 'DD-MM-AAAA' (las fechas del historial ya vienen como DD-MM-AAAA).
export const formatoFechaISO = (fecha) => {
    if (!fecha || !/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return '';
    const [anio, mes, dia] = fecha.split('-');
    return `${dia}-${mes}-${anio}`;
}

export const formatoSiNo = (valor) => {
    if (valor === 'S') return 'SI';
    if (valor === 'N') return 'NO';
    return '';
}

export const formatoMontoInforme = (monto) => {
    const numero = Number(monto);
    return Number.isFinite(numero) ? numero.toLocaleString('es-CO') : '';
}

// Qué se muestra en la sección 7 según el perfil, la versión y el estado del informe consultado.
//   Abogado y versión 1 → nada. Revisado → la decisión (seccion7); Enviado → «Pendiente…»; Borrador → nada.
export const estadoSeccion7 = (estado, seccion7, perfil, nroVersion) => {
    if (perfil === PERFIL_ABOGADO && nroVersion === 1) return 'OCULTA';
    if (estado === ESTADO_REVISADO && seccion7) return 'DECISION';
    if (estado === ESTADO_ENVIADO) return 'PENDIENTE';
    return 'OCULTA';
}
